import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';

import { environment } from './../../../../../environments/environment';


@Injectable()
export class EquipmentEditService {

  private urlPrefix: string = environment.appUrl;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe
  ) { }

  edit(equipmentId, post, staticRemarks): Observable<any> {
    const url = this.urlPrefix + 'equipments/' + equipmentId + '/static';
    return this.http
      .put(url, {
        siteId: Number(post.siteId.value),
        productCategoryId: post.productCategory.value[0].id,
        brand: post.brand.value,
        model: post.model.value,
        designationNumber: post.designationNumber.value,
        productName: post.productName.value,
        serialNumber: post.serialNumber.value,
        description: post.description.value,
        type: post.type.value,
        ratingOrCapacity: post.ratingOrCapacity.value,
        remarks: staticRemarks,
        // forms: post.forms.value instanceof Array ? post.forms.value.map(f => f.id) : []
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

  editJob(equipmentId, jobId, post): Observable<any> {
    const url = this.urlPrefix + 'equipments/' + equipmentId + '?jobs=' + jobId;
    return this.http
      .put(url, {
          batteryQuantity: post.batteryQuantity.value,
          batteryBrand: post.batteryBrand.value,
          batteryModel: post.batteryModel.value,
          // fireServiceExpiryDate: this.datePipe.transform(post.fireServiceExpiryDate.value, 'yyyy-MM-dd'),
          fireServiceExpiryDate: post.fireServiceExpiryDate.value,
          spareParts: post.spareParts.value,
          vendorOrSubcontractor: post.vendorOrSubcontractor.value,
          contractStartDate: this.datePipe.transform(post.contractStartDate.value, 'yyyy-MM-dd'),
          contractEndDate: this.datePipe.transform(post.contractEndDate.value, 'yyyy-MM-dd'),
          ecall: post.ecall.value,
          remarks: post.remarks.value
      }, { observe: 'response' })
      .map(
        res => {
          if (res.status === 200) {
            return res.body;
          } else {
            return Observable.throw(null);
          }
        }
      )
      .catch(
        err => {
          return Observable.throw(err);
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-edit/equipment-edit.service.ts